<template>
<Dialog v-model="visible" :width="1280" setting @setting="$emit('setting')">

  <template slot="title">
    <span class="title">{{ $t(`type.ILLUMINATION`) }}</span>
  </template>

  <template slot="menu">
    <HistoryRangeSelector v-model="dataType"></HistoryRangeSelector>
  </template>

  <LineChart :data="data" :options="options"></LineChart>

</Dialog>
</template>

<script>
import Dialog from '@/components/utils/dialog/Dialog'
import LineChart from '@/components/chart/LineChart'
import DataChartDialog from '@/components/chart/DataChartDialog'
import HistoryRangeSelector from '@/components/utils/HistoryRangeSelector'

export default {
  name: 'IlluminationChartDialog',
  mixins: [DataChartDialog],
  components: {
    Dialog,
    LineChart,
    HistoryRangeSelector
  },
  computed: {
    data() {
      return {
        datasets: [{
          data: this.itemKeys.map(t => ({
            t: parseInt(t),
            y: (this.rawData[t] || {}).illumination
          })),
          borderWidth: 1.5,
          lineTension: 0,
          pointRadius: 0.5,
          fill: true,
          borderColor: this.$vuetify.theme.currentTheme.primary,
          backgroundColor: this.$vuetify.theme.currentTheme.primary + '55'
        }]
      };
    },
    options() {
      return {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              max: this.timestamp
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: 0,
              suggestedMin: 0
            },
            scaleLabel: {
              display: !!this.unit,
              labelString: this.unit
            }
          }]
        },
        tooltips: {
          intersect: false,
          mode: 'index',
          axis: 'x'
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: false
      };
    }
  }
}
</script>
